/** @jsxImportSource @emotion/react */
import { useState } from "react";
import useBreakpoint from "../../hooks/useBreakpoint";
import { theme } from "../../theme/theme";
import Box from "../Box/Box";
import DisplayContentLayout from "../Layout/DisplayContentLayout";
import Stepper from "../Stepper/Stepper";
import Typography from "../Typography/Typography";
import CopyRight from "../CopyRight/CopyRight";

type ImageHeadlineDisplayProps = {
  imageUrl: string;
  categoryTitle: string;
  description: string;
  copyRightLabel: string;
  onClose: () => void;
  slideId: number;
};
const ImageHeadlineDisplay = ({
  imageUrl,
  categoryTitle,
  description,
  onClose,
  slideId,
  copyRightLabel,
}: ImageHeadlineDisplayProps) => {
  const [imgOpacity, setImgOpacity] = useState(0);

  const { isTablet, isLandscape, isMobile } = useBreakpoint();

  return (
    <DisplayContentLayout imgOpacity={imgOpacity} handleClick={onClose}>
      {isMobile && (
        <Box>
          <Box
            height="100%"
            width="100vw"
            padding={30}
            marginTop={isMobile ? "13vh" : undefined}
          >
            <div css = {{position: 'relative'}}>
              <img
                css={{
                  width: "100%",
                  height: 240,
                  objectFit: "cover",
                  borderBottomRightRadius: "0px",
                }}
                src={imageUrl}
                alt="Heidelberg image"
                onLoad={() => setImgOpacity(1)}
              />
              <CopyRight copyRightLabel={copyRightLabel} />
            </div>
            <Typography
              variant={isMobile ? "h2_mobile" : "h2"}
              marginTop={16}
              marginBottom={16}
              maxWidth={250}
              css={{
                color: theme.colors.primary,
                fontSize: isMobile ? 16 : undefined,
              }}
            >
              {categoryTitle}
            </Typography>

            <Typography
              variant={isMobile ? "body1_mobile" : "body1"}
              color="primary"
            >
              {description}
            </Typography>
          </Box>

          <Box display="flex" justifyContent="flex-end" marginRight={30}>
            <Stepper slideId={slideId} />
          </Box>
        </Box>
      )}

      {!isMobile && (
        <Box>
          <Box display="flex" justifyContent="space-between">
            <Box
              style={{
                width: 565,
                height: 340,
                backgroundColor: theme.colors.primary,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderTopLeftRadius: "190px",
              }}
            >
              <Typography variant="h2" css={{ color: "white", padding: 100 }}>
                {categoryTitle}
              </Typography>
            </Box>
            <Box
              style={{
                width: 255,
                height: 255,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                paddingTop: 100,
              }}
            >
              <Box
                style={{
                  width: "100%",
                  height: "100%",
                  backgroundColor: theme.colors.red,
                  borderTopRightRadius: "190px",
                }}
              ></Box>
            </Box>
          </Box>

          <Box display="flex">
            <Box
              style={{
                width: 450,
                height: 400,
                paddingTop: 20,
                paddingRight: 20,
              }}
            >
              <Typography variant="body1" color="primary">
                {description}
              </Typography>
            </Box>
            <Box
              style={{
                width: 385,
                height: 385,
                borderBottomRightRadius: "190px",
                marginTop: -100,
                marginRight: 100,
                position: "relative",
              }}
            >
              <img
                css={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderBottomRightRadius: "190px",
                }}
                src={imageUrl}
                alt="Heidelberg image"
                onLoad={() => setImgOpacity(1)}
              />
              {!!copyRightLabel && <CopyRight copyRightLabel={copyRightLabel} />}
            </Box>
          </Box>

          <Box position="absolute" right={0} paddingBottom={30}>
            {isTablet || isLandscape ? <Stepper slideId={slideId} /> : <></>}
          </Box>
        </Box>
      )}
      
    </DisplayContentLayout>
  );
};

export default ImageHeadlineDisplay;
